import type { PropsWithChildren } from 'react'
import { rolesLeaderOrHigher } from '~/domain/user/userRole'
import { OnlyOnlineRoute } from './OnlyOnlineRoute'
import { ProtectedRoute } from './ProtectedRoute'
import { RolesRequiredRoute } from './RolesRequiredRoute'

export function TemplateHideSettingRoute({ children }: PropsWithChildren) {
  return (
    <ProtectedRoute>
      <RolesRequiredRoute rolesRequired={rolesLeaderOrHigher}>
        <OnlyOnlineRoute>{children}</OnlyOnlineRoute>
      </RolesRequiredRoute>
    </ProtectedRoute>
  )
}
